import { Typography } from '../../index'
import { useState } from 'react'
import { Check } from '../../../icons'
import cn from 'clsx'

type props = {
  onChange: (value: boolean) => void
  value: boolean | undefined
  multiple?: boolean | undefined
  label: string
  containerClassName?: string
}

function Radio({
  onChange,
  value,
  multiple,
  label,
  containerClassName = '',
}: props) {
  const activeRingClassName =
    'flex flex-col justify-center items-center transition-all duration-300 w-[18px] h-[18px] border-2 border-indigo-500 ml-2 p-0.5 ' +
    (multiple ? 'rounded bg-indigo-500' : 'rounded-full ')
  const ringClassName =
    'flex flex-col justify-center items-center transition-all duration-300 w-[18px] h-[18px] border-2 border-gray-400 ml-2 p-0.5 ' +
    (multiple ? 'rounded ' : 'rounded-full ')
  const activeDotClassName =
    'w-[100%] h-[100%] bg-indigo-500 transition-all duration-300 ' +
    (multiple ? 'rounded' : 'rounded-full ')
  const dotClassName =
    'w-[1px] h-[1px] transition-all duration-300 ' +
    (multiple
      ? 'rounded hover:bg-indigo-500 hover:border-indigo-500'
      : 'rounded-full  bg-white ')
  const [hovered, setHovered] = useState(false)
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => onChange(!value)}
      className={cn(
        'transition-all items-center duration-300 p-0 cursor-pointer ',
        {
          ['text-indigo-500 border-indigo-500']: value,
          ['rounded-md flex shadow-md lg:shadow-none border-2 border-gray px-5 py-2 hover:border-indigo-500']:
            !!label,
        },
        containerClassName
      )}
    >
      <Typography>
        <span
          className={`${
            value || hovered ? 'text-indigo-500' : 'text-gray-400'
          } font-semibold`}
        >
          {label}
        </span>
      </Typography>
      <div className={value || hovered ? activeRingClassName : ringClassName}>
        {multiple ? (
          <Check
            className={`transition-all duration-300 ${
              value ? 'text-white' : 'text-transparent'
            }`}
            width={12}
            strokeWidth={4}
            height={12}
          />
        ) : (
          <div className={value ? activeDotClassName : dotClassName}></div>
        )}
      </div>
    </div>
  )
}

export default Radio
